import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHttpService } from '@app/core/services/base-http.service';
import { ReservationHistoryListItem } from './reservation-history.model';

@Injectable({
  providedIn: 'root'
})
export class ReservationsHistoryService extends BaseHttpService {
  // The reservation system backend serves this (currently mock data, sourced from the Booking
  // system once its API is ready).
  getReservationHistory(reservationUid: string): Observable<ReservationHistoryListItem[]> {
    return this.httpClient.get<ReservationHistoryListItem[]>(
      `${this.baseApiUrl}/api/reservationHistory/${reservationUid}`
    );
  }
}
